import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "prize" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "prize-shadow" }, null, -1)
const _hoisted_3 = { class: "prize-type" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("點數")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("折扣碼")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("儲值金")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button2 = _resolveComponent("Button2")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Button2, {
        class: "prize-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchPrizeIndex('Home-Prize-Point'))),
        isActive: _ctx.$route.name.includes('Home-Prize-Point')
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["isActive"]),
      _createVNode(_component_Button2, {
        class: "prize-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchPrizeIndex('Home-Prize-Coupon'))),
        isActive: _ctx.$route.name.includes('Home-Prize-Coupon')
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["isActive"]),
      _createVNode(_component_Button2, {
        class: "prize-button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchPrizeIndex('Home-Prize-Money'))),
        isActive: _ctx.$route.name.includes('Home-Prize-Money')
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["isActive"])
    ]),
    _createVNode(_component_router_view, {
      class: "prize-content",
      groupId: _ctx.groupId
    }, null, 8, ["groupId"])
  ]))
}